<template>
  <RootProductCe v-if="bookInfoComputed && windowWidth >= 1100" :book-info="bookInfoComputed"
    @to-basket="basketStore.addBasketProduct($event.id)" 
    @open-basket="basketStore.toBasket"
    @event:image-clicked="showImage($event)"
    >
    <slot> </slot>
  </RootProductCe>
  <RootProductMobileCe v-if="bookInfoComputed && windowWidth < 1100" :book-info="bookInfoComputed"
    @to-basket="basketStore.addBasketProduct($event.id)" 
    @open-basket="basketStore.toBasket"
    @event:image-clicked="showImage($event)"
    >
    <slot> </slot>
  </RootProductMobileCe>
</template>
<script lang="ts" setup>
import RootProductCe from '@/components/product/RootProduct.ce.vue'
import { useBasketStore } from '@/stores/basket'
import type { BookItem } from '@/types/book_item'
import { computed, onMounted, ref } from 'vue'
import { useWindowSize } from '@vueuse/core'
import RootProductMobileCe from '@/components/product/mobile/RootProductMobile.ce.vue'
import photoswipeUrl from 'photoswipe/style.css?url'
import { getWithHost, addCssToHead } from '@/utils/utils'
import PhotoSwipeLightbox from 'photoswipe/lightbox'
import PhotoSwipe, { type SlideData } from 'photoswipe'

addCssToHead(getWithHost(photoswipeUrl))

const props = defineProps<{
  data: string
}>()

const bookInfo = ref<BookItem>()
const basketStore = useBasketStore()

const { width: windowWidth } = useWindowSize()

const bookInfoComputed = computed<BookItem | undefined>(() => {
  if (!bookInfo.value) {
    return undefined
  }
  const inBascedItem = basketStore.items.find((v) => v.product_id == bookInfo.value?.id)
  if (!inBascedItem) {
    return bookInfo.value
  }

  return { ...bookInfo.value, in_bascet: true }
})

onMounted(() => {
  bookInfo.value = JSON.parse(props.data)
  console.log('bookInfo', bookInfo.value)
})

const photoSwipeImages = computed<SlideData[]>(() => {
  if (!bookInfoComputed.value?.images) {
    return [] as SlideData[];
  }
  return bookInfoComputed.value.images.map((v, key) => {
    const ie = {
      id: key + 1,
      src: getWithHost(v.full.src),
      width: v.full.width,
      height: v.full.height
    } as unknown as SlideData

    return ie;
  })
})


let lightbox : PhotoSwipeLightbox 

onMounted(() => {
  lightbox = new PhotoSwipeLightbox({
    pswpModule: PhotoSwipe,
    dataSource: photoSwipeImages.value,
  });
  
  lightbox.init();
})

const showImage = (index: number) => {
  lightbox.loadAndOpen(index)
}

</script>